import { render } from "./CIS-Alert.vue?vue&type=template&id=52041320&scoped=true"
import script from "./CIS-Alert.vue?vue&type=script&lang=js"
export * from "./CIS-Alert.vue?vue&type=script&lang=js"

import "./CIS-Alert.vue?vue&type=style&index=0&id=52041320&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52041320"]])

export default __exports__